import React, { PureComponent } from "react";

import TagSelect from "Common/TagSelect";

import styles from "./Branch.local.scss";
import classnames from "classnames";

export default class BranchComponent extends PureComponent {
  constructor() {
    super();

    this.state = {
      displayTagSelect: false,
      hoverTagSelect: false,
      branch: null
    };
  }

  componentDidMount() {
    const { branch } = this.props;
    this.setState({
      branch: branch,
      displayTagSelect:
        this.props.branch !== undefined && this.props.branch !== null
    });
  }

  deleteNode(parentId, branchId, nodes) {
    if (nodes.id === parentId) {
      return nodes.filter(node => node.id !== branchId);
    } else {
      if (nodes.ch && nodes.ch.length > 0)
        nodes.ch.map(function(child) {
          return this.deleteNode(parentId, branchId, child);
        });
      else {
        return [];
      }
    }
  }

  removeTag = (parentId, branchId) => e => {
    const { onRemove } = this.props;
    if (branchId) {
      onRemove(parentId, branchId);
    } else {
      this.setState({ displayTagSelect: false });
    }
    // nodes = this.deleteNode(parentId, branchId, nodes);

    // if (this.state.displayTagSelect) {
    //   console.log("remove");
    // } else {
    //   console.log("show");
    // }
    // this.setState({ displayTagSelect: !this.state.displayTagSelect });
  };
  clickAdd = e => {
    const { onClickAdd } = this.props;
    this.setState({ displayTagSelect: !this.state.displayTagSelect });
    onClickAdd();
  };
  handleHover = e => {
    const { activateEdit } = this.props;
    if (activateEdit && e.currentTarget.classList.contains(styles.selected)) {
      this.setState({ hoverTagSelect: true });
    }
    // }
    /*e.currentTarget
      .getElementsByClassName(styles.tagSelect)
      .item(0)
      .classList.remove(styles.full);
    e.currentTarget
      .getElementsByClassName(styles.plus)
      .item(0)
      .classList.remove(styles.hide);*/
  };
  handleLeave = e => {
    if (e.currentTarget.classList.contains(styles.selected)) {
      this.setState({ hoverTagSelect: false });
    }
    /*e.currentTarget
      .getElementsByClassName(styles.tagSelect)
      .item(0)
      .classList.add(styles.full);

    e.currentTarget
      .getElementsByClassName(styles.plus)
      .item(0)
      .classList.remove(styles.hide);*/
  };

  handelChange = tag => {
    if (tag.id) {
      const { onChange, id } = this.props;
      const { branch } = this.state;
      onChange(id, branch, tag);
      if (!branch)
        this.setState({
          branch: null,
          displayTagSelect: false,
          hoverTagSelect: false
        });
      else {
        this.setState({
          hoverTagSelect: false
        });
      }
    }
  };

  renderButtons = () => {
    const { id, tagSelected } = this.props;
    const { displayTagSelect, hoverTagSelect, branch } = this.state;
    const branchId = branch ? branch.id : null;
    if (displayTagSelect)
      return (
        <button
          className={classnames(
            styles.plus,
            displayTagSelect ? styles.delete : "",
            tagSelected && !hoverTagSelect ? styles.hide : ""
          )}
          onClick={this.removeTag(id, branchId)}
        />
      );
    else
      return (
        <button
          className={classnames(
            styles.plus,
            displayTagSelect ? styles.delete : "",
            tagSelected && !hoverTagSelect ? styles.hide : ""
          )}
          onClick={this.clickAdd}
        />
      );
  };

  renderTagName = () => {
    const { branch } = this.state;
    const { lng } = this.props;

    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
    if (branch && branch[nameAttr])
      return <span className={styles.tagName}>{branch[nameAttr]}</span>;
    else return <span className={styles.tagName} />;
  };

  render() {
    const {
      id,
      lng,
      setValue,
      onChange,
      tagSelected,
      activateEdit,
      extraClasses
    } = this.props;
    const { displayTagSelect, hoverTagSelect, branch } = this.state;
    const branchId = branch ? branch.id : null;
    return (
      <div
        className={classnames(
          styles.branch,
          extraClasses || "",
          tagSelected ? styles.selected : ""
        )}
        onMouseEnter={this.handleHover.bind(this)}
        onMouseLeave={this.handleLeave.bind(this)}
      >
        <div
          className={classnames(
            displayTagSelect ? styles.activated : "",
            tagSelected && !hoverTagSelect ? styles.full : "",
            styles.tagSelect
          )}
        >
          {activateEdit ? (
            <TagSelect
              onChange={this.handelChange}
              //webtool={currentWebtool}
              lng={lng}
              tag={branch ? branch : null}
            />
          ) : (
            this.renderTagName()
          )}
        </div>
        {/* {activateEdit ? this.renderButtons() : null} */}
        {/* {!displayTagSelect ? (
          <button
            className={classnames(
              styles.plus,
              displayTagSelect ? styles.delete : "",
              tagSelected && !hoverTagSelect ? styles.hide : ""
            )}
            onClick={this.clickAdd}
          />
        ) : null} */}
        {displayTagSelect && activateEdit ? (
          <button
            className={classnames(
              styles.plus,
              displayTagSelect ? styles.delete : "",
              tagSelected && !hoverTagSelect ? styles.hide : ""
            )}
            onClick={this.removeTag(id, branchId)}
          />
        ) : null}
        {!displayTagSelect ? (
          <button className={classnames(styles.plus)} onClick={this.clickAdd} />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoriesList/Category/Branch/BranchComponent.js